module.exports = __webpack_public_path__ + "img/android-download.5a4ba1f6.png";